import { render } from "./UpdateTime.vue?vue&type=template&id=64526612"
import script from "./UpdateTime.vue?vue&type=script&lang=js"
export * from "./UpdateTime.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__